(function(){
  'use strict';

  function setNativeValue(input, value){
    var descriptor = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype,'value');
    if(descriptor && descriptor.set){
      descriptor.set.call(input,value);
    }else{
      input.value = value;
    }
    input.dispatchEvent(new Event('input',{bubbles:true}));
    input.dispatchEvent(new Event('change',{bubbles:true}));
  }

  function findWideHost(input){
    var form = input.closest('.pp_tracking_form');
    var base = input.getBoundingClientRect();
    var node = input.parentElement;
    var candidate = input.parentElement;

    while(node && node !== form){
      var rect = node.getBoundingClientRect();

      if(
        rect.width >= base.width * 1.35 &&
        rect.height >= 40 &&
        rect.height <= 110
      ){
        candidate = node;
        break;
      }

      node = node.parentElement;
    }

    return candidate;
  }

  function mountProxy(input, index){
    if(!input || input.dataset.gpProxyMounted === '1') return;

    var host = findWideHost(input);
    if(!host) return;

    input.dataset.gpProxyMounted = '1';
    host.classList.add('gp-track-proxy-host');

    var proxy = document.createElement('input');
    proxy.type = 'text';
    proxy.className = 'gp-track-proxy-input';
    proxy.value = input.value || '';
    proxy.autocomplete = input.autocomplete || 'off';
    proxy.inputMode = input.inputMode || 'text';

    var labelText = '';
    var label = host.previousElementSibling;
    if(label && label.textContent) labelText = label.textContent.trim();
    if(!labelText){
      var formLabel = input.closest('.PP-FormLayout__Item');
      if(formLabel){
        var textLabel = formLabel.querySelector('label,.PP-Label,.PP-Label__Text');
        if(textLabel) labelText = textLabel.textContent.trim();
      }
    }
    if(labelText) proxy.setAttribute('aria-label',labelText);

    proxy.addEventListener('input',function(){
      setNativeValue(input,proxy.value);
    });
    proxy.addEventListener('change',function(){
      setNativeValue(input,proxy.value);
    });

    host.appendChild(proxy);
    host.classList.add('gp-track-proxy-ready');
  }

  function normalize(){
    var app = document.getElementById('pp-tracking-page-app');
    if(!app) return;

    var inputs = app.querySelectorAll('.PP-TextField__Input');
    inputs.forEach(function(input,index){
      mountProxy(input,index);
    });
  }

  function start(){
    normalize();

    var app = document.getElementById('pp-tracking-page-app');
    if(!app) return;

    var observer = new MutationObserver(function(){
      window.requestAnimationFrame(normalize);
    });

    observer.observe(app,{childList:true,subtree:true});

    [100,250,500,900,1500,2500].forEach(function(delay){
      window.setTimeout(normalize,delay);
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded',start,{once:true});
  }else{
    start();
  }
})();